export default {
  series: 3,
  data: 'Country;Value\nus-al;4\nus-ar;10\nus-az;2\nus-ca;5\nus-ct;20\nus-dc;10\nus-de;30\nus-fl;40\nus-ga;55\nus-hi;20\nus-ia;5\nus-id;30\nus-il;50\nus-in;40\nus-ks;44\nus-ky;50\nus-la;2\nus-ma;20\nus-md;100\nus-me;10\nus-mi;30\nus-mn;100\nus-ne;40\nus-nm;100\nus-ok;10\nus-ri;40\nus-tn;50\nus-tx;40\nus-ut;70\nus-wa;80\nus-wv;20',
  seriesMapping: [
    {
      'hc-key': 0,
      value: 1,
      x: 1
    },
    {
      'hc-key': 0,
      z: 1,
      x: 1
    },
    {
      'hc-key': 0,
      value: 1,
      x: 1
    }
  ],
  assignDataFields: [
    {
      labels: 'A',
      value: 'B'
    },
    {
      labels: 'A',
      value: 'B'
    },
    {
      labels: 'A',
      value: 'B'
    }
  ],
  seriesOptions: [
    {
      joinBy: 0,
      type: 'map'
    },
    {
      joinBy: 'hc-key',
      type: 'mapbubble'
    },
    {
      type: 'mapline',
      color: 'silver',
      showInLegend: false,
      enableMouseTracking: false
    }
  ],
  seriesTemplate: ['map', 'mapbubble', 'mapline']
};
